import styled from '@emotion/styled';
import { H3, Text } from 'ds/components/typography';

export const EmptyWrapper = styled.div`
  max-width: 376px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing(20)};
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin-top: ${theme.spacing(14)};
  `}
`;

export const EmptyTitle = styled.div`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  text-align: center;
  font-size: 25px;
  font-weight: 700;
  line-height: 32px;
  margin-top: ${({ theme }) => theme.spacing(3)};
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

export const EmptyText = styled(Text)`
  color: ${({ theme }) => theme.colors.neutrals.grey2};
  text-align: center;
`;

export const StarWrapper = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.round};
  border: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
`;

export const Wrapper = styled.div`
  max-width: 1224px;
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.spacing(3)};
`;

export const ListWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(3)};
  flex-wrap: wrap;
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    margin-top: ${theme.spacing(5)};
  `}
`;

export const Title = styled(H3)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  margin-top: ${({ theme }) => theme.spacing(5)};
  margin-bottom: ${({ theme }) => theme.spacing(3)};
`;
